import React from "react";

const Announcement = () => {
  return <div>Announcement</div>;
};

export default Announcement;
